import React, { useReducer } from "react";
import AppContext from "./appContext";
import helper from "../common/helper";
import {
  USERDETAILS,
  ISLOADING,
  SETUSERTYPE,
  LOGOUT,
  CARTLIST,
  SETUSERPROFILE,
  SETORGLOGO,
  SETGLOBALTHEME,
  UNREADMSGCOUNT,
  SETMUSTACCEPTLEGAL,
} from "./constants";
export const GlobalState = (props) => {
  const userImage = helper.SecureStorageFunc("userProfile", "get", "");
  const _userType = helper.SecureStorageFunc("userType", "get", "");
  let _userDetails;
  try {
    _userDetails = helper.getStoredUserData() || {};
  } catch {
    _userDetails = {};
  }
  const organisationLogo = helper.SecureStorageFunc(
    "organisationLogo",
    "get",
    ""
  );

  const updateThemeStorage = (updatedUserObj) => {
    helper.SecureStorageFunc("userData", "set", updatedUserObj);
  };
  if (_userDetails && _userDetails.organisationTheme) {
    var bodyStyles = document.body.style;
    bodyStyles.setProperty(
      "--primary-color",
      _userDetails.organisationTheme.primaryColor
    );
    bodyStyles.setProperty(
      "--secondary-color",
      _userDetails.organisationTheme.secondryColor
    );
    bodyStyles.setProperty(
      "--sadow-color",
      _userDetails.organisationTheme.sadowColor
    );
  }

  const initialState = {
    UserDetails: _userDetails || {},
    userImage,
    organisationLogo,
    themeColor: "blue",
    userType: _userType,
    isLoading: false,
    cartList: [],
    unreadMsgCount: 0,
    mustAcceptLegal: localStorage.getItem('mustAcceptLegal') === 'true',
  };
  function reducer(state, action) {
    switch (action.type) {
      case USERDETAILS:
        return { ...state, UserDetails: action.payload };
      case ISLOADING:
        return { ...state, isLoading: action.payload };
      case SETUSERTYPE:
        return { ...state, userType: action.payload };
      case SETUSERPROFILE:
        return { ...state, userImage: action.payload };
      case SETORGLOGO:
        helper.SecureStorageFunc("organisationLogo", "set", action.payload);
        return {
          ...state,
          organisationLogo: action.payload,
          UserDetails: {
            ...state.UserDetails,
            organisationLogo: action.payload,
          },
        };
      case SETGLOBALTHEME:
        const updatedState = {
          ...state.UserDetails,
          organisationTheme: action.payload,
        };
        updateThemeStorage(updatedState);
        return {
          ...state,
          UserDetails: {
            ...state.UserDetails,
            organisationTheme: action.payload,
          },
        };
      case CARTLIST:
        return { ...state, cartList: action.payload };
      case LOGOUT:
        helper.SecureStorageFunc(null, "clear");
        return { isLoading: false, data: {}, cartList: [] };
      case UNREADMSGCOUNT:
        return { ...state, unreadMsgCount: action.payload };
      case SETMUSTACCEPTLEGAL:
        return { ...state, mustAcceptLegal: action.payload };
      default:
        return state;
    }
  }
  //using the useReducerHook
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <AppContext.Provider
      value={{
        state: state,
        dispatch: dispatch,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};
